import { defineMessages } from 'react-intl'

export default defineMessages({
  unknown: {
    id: 'unknown',
    defaultMessage: 'Unknown',
  },
})
